<template>
  <textarea
    v-model="comment"
    :placeholder="data.tooltip"
    name="rating_comment"
    id="rating_comment"
    cols="30"
    rows="5"
  >
  </textarea>
</template>

<script>
export default {
  props: {
    data: {},
  },
  data() {
    return {
      comment: '',
    };
  },
  watch: {
    comment(newValue) {
      this.$emit('changeValue', {
        field_type: 'text_input',
        value: newValue,
        field_id: this.data.id,
      });
    },
  },
};
</script>

<style lang="scss">
textarea {
  width: 100% !important;
  border-color: #949494 !important;
  border-radius: 10px;
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/rating/fields/fieldTextArea.vue